import i18n from '@dms/i18n';

export const getTemplateCopyTitle = (title: string) =>
  i18n.t('entity.documentTemplateEditor.labels.copyTitle', {title});
